export default __webpack_public_path__ + "static/media/sucursal.43321673.png";